import { html } from 'common-tags'

const ashtmaRequirements = {
  'asma-eosinofilica-grave': html`
    <p>Segundo a RESOLUÇÃO NORMATIVA - RN Nº 513, DE 31 DE MARÇO DE 2022 do Ministério da Saúde:</p>
    <p class="font-size-16 font-weight-bold">ASMA EOSINOFÍLICA GRAVE</p>
    <ol>
      <li>
        Cobertura obrigatória dos medicamentos
        <span class="font-weight-bold">Benralizumabe ou Mepolizumabe ou Dupilumabe</span> para o tratamento complementar
        da asma eosinofílica grave, quando preenchidos todos os seguintes critérios:

        <ol type="a">
          <li>
            asma <span class="font-weight-bold">não controlada</span>, apesar do uso de
            <span class="font-weight-bold"> corticoide inalatório associado a beta 2 agonista de longa duração </span>
            ; e
          </li>
          <li>
            contagem de
            <span class="font-weight-bold"> eosinófilos maior ou igual a 300 células/μl </span> nos últimos 12 meses; e
          </li>
          <li>
            <span class="font-weight-bold"> uso contínuo de corticoide oral </span> para controle da asma
            <span class="font-weight-bold"> nos últimos 6 meses ou 3 ou mais exacerbações </span> asmáticas necessitando
            de tratamento <span class="font-weight-bold"> com corticoide oral no último ano </span>.
          </li>
        </ol>
      </li>
    </ol>
  `,
  'asma-alergica-grave': html`
    <p>Segundo a RESOLUÇÃO NORMATIVA ANS Nº 550, DE 4 DE NOVEMBRO DE 2022 do Ministério da Saúde:</p>
    <p class="font-size-16 font-weight-bold">ASMA ALÉRGICA GRAVE</p>
    <ol>
      <li>
        Cobertura obrigatória dos medicamentos
        <span class="font-weight-bold">Omalizumabe ou Dupilumabe</span> para o tratamento complementar da asma alérgica
        grave, quando preenchidos todos os seguintes critérios:

        <ol type="a">
          <li>
            asma <span class="font-weight-bold">não controlada</span>, apesar do uso de
            <span class="font-weight-bold"> corticoide inalatório associado a beta 2 agonista de longa duração </span>
            ; e
          </li>
          <li>
            evidência de sensibilização a pelo menos um aeroalérgeno perene documentada por
            <span class="font-weight-bold"> teste cutâneo de puntura </span> ou dosagem de
            <span class="font-weight-bold"> IgE sérica específica </span> in vitro; e
          </li>
          <li>
            <span class="font-weight-bold"> IgE sérica total </span>, antes do início do tratamento,
            <span class="font-weight-bold"> maior ou igual a 30 UI/ml </span>; e
          </li>
          <li>
            <span class="font-weight-bold"> uso contínuo de corticoide oral </span> para controle da asma
            <span class="font-weight-bold"> nos últimos 6 meses </span> ou
            <span class="font-weight-bold"> 3 ou mais exacerbações </span> asmáticas necessitando de tratamento
            <span class="font-weight-bold"> com corticoide oral no último ano </span>.
          </li>
        </ol>
      </li>
    </ol>
  `,
}

export default ashtmaRequirements
